<div class="container">
  <div class="booking-body">
    <ng-container *ngIf="isMobile">
      <ng-container *ngTemplateOutlet="packageBookingSlider"></ng-container>
    </ng-container>
    <ng-container class="body-package-air-booking">
      <form *ngIf="user" [formGroup]="bookingPackageAirForm" class="booking-form-info">
        <ng-container *ngIf="!isMobile">
          <section class="container-upsell" [class.disabled]="!isUpsellEnabled">
            <app-travel-segment-upsell
              [isMobile]="isMobile"
              [baggage]="baggage"
              [upsellLoading]="isLoadingFligthsUpsellDesktop$ | async"
              [fareFamilies]="fareFamilies"
              [showUpsell]="isUpsellEnabled"
              [upsellSelected]="upsellSelected"
              (openUpsell)="openUpsellDesktop()">
            </app-travel-segment-upsell>
          </section>        
        </ng-container>
	      <section class="pax-section-cont">
          <ng-container *ngFor="let room of guestListUI$ | async; index as roomIndex">
            <div class="title">
              <app-ds-typography
                [tag]="'h3'"
                [size]="fontSize.XS"
                [color]="fontColor.Primary"
                [fontFamily]="fontFamily.SemiBold"
                [text]="
                  ('GUESTS' | transloco) +
                  ' - ' +
                  ('BOOKING_MODULE.PAX.ROOM_PAX_NUMER' | transloco: { room: room.roomNumber })
                ">
              </app-ds-typography>
            </div>
            <div class="description">
              <app-ds-typography
                [tag]="'p'"
                [size]="fontSize.XXS"
                [color]="fontColor.Secondary"
                [fontFamily]="fontFamily.Regular"
                [text]="'BOOKING_MODULE.PAX.ROOM_DESCRIPTION' | transloco">
              </app-ds-typography>
            </div>
            <div class="room-guest-list-cont">
              <ng-container *ngFor="let guestUI of room.roomGuests; index as guestIndex">
                <app-pax-section
                  [frequentFlyerPrograms]="frequentFlyerPrograms$ | async"
                  [validator]="airValidation"
                  [countries]="countries$ | async | countriesVm"
                  [travelerType]="guestUI.TravelerType"
                  [listUILength]="room.roomGuests.length"
                  [travelerInfoType]="guestUI.TravelerInfoType"
                  [paxTravelers]="travelers$ | async | travelerListVm : guestUI?.TravelerType : guestUII(roomIndex, guestIndex) : startDate | async"
                  [ordinalKey]="guestUI.OrdinalKey"
                  [defaultData]="guestUI.defaultData"
                  [form]="bookingPackageAirForm"
                  [user]="user"
                  [showFrequentFlyer]="true"
                  [isSubmittedSuccess]="isSubmittedSuccess"
                  [isSubmitted]="isSubmitted"
                  [travelerNumber]="guestUI.id"
                  [isMobile]="isMobile"
                  [travelerAge]="childrenAgeByPackage(roomIndex, guestUI.IndexTypeNumber, guestUI.TravelerType)"
                  [isAnInternationalTrip]="isAnInternationalTrip$ | async"
                  [travelerBookingProvider]="travelerBookingProvider"
                  [businessRules]="businessRules$ | async"
                  [productCode]="airlineCode"
                  [productProvider]="airlineProvider"
                  (createLoyalty)="createPackageLoyalty($event, roomIndex, guestIndex)"
                  (selectLoyalty)="selectPackageLoyalty($event, roomIndex, guestIndex)"
                  (removeLoyalty)="deletePackageLoyalty($event, roomIndex, guestIndex)"
                  (updateLoyalty)="updatePackageLoyalty($event, roomIndex, guestIndex)"
                  (selectPax)="selectTravelerPax($event, roomIndex, guestIndex)"
                  (removePax)="deleteTravelerPax($event, roomIndex, guestIndex)"
                  (createPax)="createTravelerPax($event, bookingPackageAirForm, { id: roomIndex, TravelerInfoType: guestUI.TravelerInfoType, guestId: guestIndex }, startDate)"
                  (updatePax)="updateTravelerPax($event, bookingPackageAirForm, { id: roomIndex, TravelerInfoType: guestUI.TravelerInfoType, guestId: guestIndex })"
                  (amplitudeEvent)="trackBookingAmplitudeEvent($event, travelerBookingProvider)"
                  (removeDefaultPax)="removeDefaultPax(roomIndex, $event)">
                </app-pax-section>
              </ng-container>
            </div>
          </ng-container>
        </section>
        <ng-container *ngIf="paxSectionReady">
          <section *ngIf="activeBillingModule" #sectionBillingRef>
            <ng-container *ngTemplateOutlet="billingSectionTemplate"></ng-container>
          </section>
          <section class="contact-info-cont" #sectionContactDetails>
            <app-contact-section
              [form]="bookingPackageAirForm"
              [isSubmitted]="isSubmitted"
              [isMobile]="isMobile"
              [user]="user">
            </app-contact-section>
          </section>
          <section>
            <app-policies-detail
              [policiesType]="policiesType"
              [isMobile]="isMobile"
              [hotelValidation]="hotelValidation"
              [airValidation]="airValidation"
              [showFreeCancellation]="false"
              [isBookingView]="true">
            </app-policies-detail>
          </section>
          <app-fare-info
            [textFare]="airValidation?.TripOption?.TextFare"
            [extraTextFare]="hotelValidation?.TextFare">
          </app-fare-info>
          <section class="content-banner">
            <ng-container *ngTemplateOutlet="chubbBookingBanner"></ng-container>
          </section>
          <section class="terms-cont" #sectionPaymentDetail *ngIf="isMobile">
            <app-package-payment-detail
              [passengerArrangement]="passengerArrangementsState$ | async"
              [price]="airPackagePrice"
              [isMobile]="isMobile"
              [conversionRate]="conversionRate$ | async">
            </app-package-payment-detail>
          </section>
          <section class="terms-cont" #sectionTermsRef>
            <app-terms-and-conditions
              [form]="bookingPackageAirForm"
              [isSubmitted]="isSubmitted">
            </app-terms-and-conditions>
          </section>
        </ng-container>
        <section *ngIf="applyConversion$ | async">
          <app-exchange-rate-info 
            [conversionRate]="conversionRate$ | async">
          </app-exchange-rate-info>
        </section>
        <section *ngIf="activeCallSupportModule">
          <app-support-info></app-support-info>
        </section>
        <app-btn-go-to-pay
          [isMobile]="isMobile"
          [disabled]="(bookingReady$ | async) === false"
          [isLoadingBooking]="isLoadingBookingDelay"
          [applyConversion]="applyConversion$ | async"
          [conversionRate]="conversionRate$ | async"
          [finalPrice]="airPackagePrice?.Total"
          [currencyCode]="airPackagePrice?.CurrencyCode"
          [productReference]="airValidation?.TripOption?.ProductReference"
          (goToPay)="submitBookingOptions($event)">
        </app-btn-go-to-pay>
      </form>
    </ng-container>
    <ng-container *ngIf="!isMobile">
      <div class="booking-payment-detail">
        <div class="payment-detail-cont">
          <ng-container *ngTemplateOutlet="paymentDetail"></ng-container>
          <ng-container *ngIf="hasHotelValidation">
            <ng-container *ngTemplateOutlet="hotelDetailBody"></ng-container>
          </ng-container>
          <ng-container *ngIf="hasAirValidation">
            <ng-container *ngTemplateOutlet="airDetailBody"></ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #hotelDetailSegment>
  <ng-container *ngIf="hotelValidation?.HotelReservation as hotelReservation">
    <div class="hotel-resume-cont" [class.air-one-way]="isOneWayTripType">
      <ng-container *ngIf="airValidation | airValidationVm as validator">
        <div class="step-resume-header" (click)="showPackageDetail({ validator: validator, sectorNumber: null }, packageBookingDetailViewType.HOTEL)">
          <div class="stay">
            <span><strong>{{'PACKAGES_MODULES.PACKAGE_BOOKING.YOUR_STAY' | transloco }}</strong> {{dateStay(hotelReservation.Checkin, hotelReservation.Checkout)}}</span>
          </div>
          <i aria-hidden="true" class="icon-expand"></i>
        </div>
        <app-hotel-segment-detail
          [isPackageBooking]="true"
          [showRoomsDetail]="!isOneWayTripType"
          [hotelReservation]="hotelReservation"
          (showHotelDetail)="showPackageDetail({ validator: validator, sectorNumber: null }, packageBookingDetailViewType.HOTEL)">
        </app-hotel-segment-detail>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #flightSectors>
  <app-travel-segment-detail
    [upsellLoading]="isLoadingUpsell$ | async"
    [showUpsell]="isUpsellEnabled"
    [upsellSelected]="upsellSelected"
    [isPackageBookingResume]="true"
    [noShadow]="true"
    [validationVm]="airValidation | airValidationVm"
    [fareFamilies]="fareFamilies"
    [summaryProvider]="packageAirSummaryProvider"
    [isInternational]="isAnInternationalTrip$ | async"
    (showFlightDetail)="showPackageDetail($event, packageBookingDetailViewType.AIR)"
    (openUpsell)="checkUpsell()">
  </app-travel-segment-detail>
</ng-template>

<ng-template #paymentDetail>
  <app-package-payment-detail
    [passengerArrangement]="passengerArrangementsState$ | async"
    [price]="airPackagePrice"
    [conversionRate]="conversionRate$ | async"
    [productReference]="airValidation?.TripOption?.ProductReference">
  </app-package-payment-detail>
</ng-template>

<ng-template #airDetailBody>
  <app-itinerary-detail
    [isMobile]="isMobile"
    [flightClass]="flightClass$ | async"
    [airValidationSector]="airValidation?.TripOption?.Sectors"
    [travelType]="travelerBookingProvider"
    [isInternational]="isAnInternationalTrip$ | async">
  </app-itinerary-detail>
</ng-template>

<ng-template #hotelDetailBody>
  <app-hotel-reservation
    [image]="hotelValidation?.HotelReservation?.Hotel?.Thumbnail"
    [hotelName]="hotelValidation?.HotelReservation?.Hotel?.HotelName"
    [stars]="hotelValidation?.HotelReservation?.Hotel?.Category"
    [destinationName]="hotelValidation?.HotelReservation?.DestinationName"
    [location]="hotelValidation?.HotelReservation?.Hotel?.FullAddress"
    [checkin]="hotelValidation?.HotelReservation?.Checkin"
    [checkout]="hotelValidation?.HotelReservation?.Checkout"
    [rooms]="hotelValidation?.HotelReservation?.Rooms">
  </app-hotel-reservation>
</ng-template>

<ng-template #packageBookingSlider>
  <div class="carousel-itinerary-list">
    <app-carousel [styleDots]="styleDots" [autoMoveItems]="false">
      <div content class="hotel-carousel-item partial-lg">
        <ng-container *ngTemplateOutlet="hotelDetailSegment"></ng-container>
      </div>
      <div content class="air-carousel-item partial-lg">
        <ng-container *ngTemplateOutlet="flightSectors"></ng-container>
      </div>
    </app-carousel>
  </div>
</ng-template>

<ng-template #billingSectionTemplate>
  <ng-container *ngIf="billingModuleIsOptional; else billingModuleTemplate">
    <ng-container *ngTemplateOutlet="optinalBillingModuletemplate"></ng-container>
  </ng-container>

  <ng-template #optinalBillingModuletemplate>
    <app-optional-billing-box
      [showBillingModule]="showBillingModule"
      (setShowBillingModule)="setShowBillingModule($event)">
    </app-optional-billing-box>
    <ng-container *ngTemplateOutlet="billingModuleTemplate; context: { hiddenHeader: true }"></ng-container>
  </ng-template>
  
  <ng-template #billingModuleTemplate let-hiddenHeader='hiddenHeader'>
    <ng-container *ngIf="showBillingModuleData">
      <app-billing
        [isSubmitted]="isSubmitted"
        [bookingForm]="bookingPackageAirForm"
        [countries]="countries$ | async | countriesVm"
        [cities]="cities$ | async"
        [user]="user"
        [showHeaderInfo]="!hiddenHeader"
        [isMobile]="isMobile">
      </app-billing>
    </ng-container>
  </ng-template>
</ng-template>

<ng-container *ngIf="showUpsellsFormModal">
  <app-modal>
    <ng-container content>
      <ng-container *ngTemplateOutlet="upsellsForm"></ng-container>
    </ng-container>
  </app-modal>
</ng-container>

<ng-template #upsellsForm>
  <app-desktop-upsell
    #upsellsFormRef
    [isPackages]="true"
    [firstFlightByTripOption]="airValidation?.TripOption?.Sectors[0]?.Flights[0]"
    [defaultOption]="upsellOptionId"
    [fligthsUpsell]="fligthsUpsellDesktop$ | async"
    (toggleShowForm)="toggleUpsellForm(false)">
  </app-desktop-upsell>
</ng-template>

<ng-template #chubbBookingBanner let-isPayment="isPayment">
  <ng-container *ngIf="!!hasTravelerInfoList">
    <app-chubb-booking-banner
      [bookingType]="travelerBookingProvider"
      [days]="airValidation.TripOption.LengthOfStay"
      [travelers]="travelerInfoList?.length"
      [isInternationalTrip]="isAnInternationalTrip$ | async"
      [isPayment]="!!isPayment"
      [assistanceInfo]="assistanceSearchInfo$ | async"
      [isActivateFreeChubbAssistance]="isActivateFreeChubbAssistance$ | async"
      [isPrimeUser]="isPrimeUser$ | async"
      (showPaymentOfferDetails)="setShowAssistanceDetails(true)">>
    </app-chubb-booking-banner>
  </ng-container>
</ng-template>

<app-travel-assistance
  [bookingType]="travelerBookingProvider"
  [isMobile]="isMobile"
  [showAssistanceInfo]="showAssistanceInfo$ | async"
  [assistanceInfo]="assistanceSearchInfo$ | async"
  [totalPrice]="airPackageTotalPrice(airValidation,hotelValidation)"
  [isLoading]="isLoadingBookingDelay"
  [showDetailInfo]="showAssistanceDetails$ | async"
  [applyConversion]="applyConversion$ | async"
  [conversionRate]="conversionRate$ | async"
  
  (hiddenAssistanceDetails)="setShowAssistanceDetails(false)"
  (payButtonEvent)="submitBookingOptionsByAssistance(bookingPackageAirForm.value, $event)"
  (exitEvent)="closeAssistanceInfo()"
  
  (amplitudeTrigger)="trackBookingAmplitudeEvent($event, travelerBookingProvider)">
  <ng-container assistanceBanner>
    <ng-container *ngTemplateOutlet="chubbBookingBanner; context: { isPayment: true }"></ng-container>
  </ng-container>
</app-travel-assistance>
